import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AxiosError } from "axios";

import { IGiveawayAuto } from "../../../interfaces";

import { EmitError } from "../../../utils/EmitError";
import { EmitSuccessAlert } from "../../../utils/EmitSuccessAlert";
import GiveawaysAutoService from "../../../services/http/services/GiveawaysAutoService";

export default function useEditGiveawayAuto() {
    const [giveawayAuto, setGiveawayAuto] = useState<IGiveawayAuto>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { id } = useParams();

    const navigate = useNavigate();

    useEffect(() => {
        const controller = new AbortController();

        async function loadGiveaway() {
            try {
                setIsLoading(true);
                const userData = await GiveawaysAutoService.getGiveawayById({id: Number(id), signal: controller.signal});

                setGiveawayAuto(userData);
                setIsLoading(false);
            } catch (err) {
                if (err instanceof AxiosError && err.name === 'CanceledError') {
                    return;
                }

                setIsLoading(false);

                EmitError(err, true, 'editGiveaway_opasdasjpdasd');

                navigate('/sorteios/auto');
            }
        }

        loadGiveaway();

        return () => {
            controller.abort();
        }
    }, [id, navigate]);

    async function handleSubmit(giveawayData: IGiveawayAuto) {
        const newGiveawayData = await GiveawaysAutoService.updateGiveaway(Number(id), giveawayData);

        EmitSuccessAlert('Sorteio atualizado com sucesso!');
        setGiveawayAuto(newGiveawayData);
    }

    return {
        isLoading,
        giveawayAuto,
        handleSubmit,
    }
}
